import { formatDBDate } from "@utils/general/format-db-date";

const getCustomerName = (row: any) =>
  row?.customer_name || row?.customer_first_name || "";

const getBusinessUnitName = (row: any) =>
  row?.business_unit_name || row?.customer_business_unit_name || "";

export const formatDeliveryOrderByCustomerLabel = (row: any) => {
  const customerName = `${getCustomerName(row)}`.trim();
  const businessUnitName = `${getBusinessUnitName(row)}`.trim();

  if (!customerName) {
    return "-";
  }

  if (!businessUnitName) {
    return customerName;
  }

  if (customerName.includes(`(${businessUnitName})`)) {
    return customerName;
  }

  return `${customerName} (${businessUnitName})`;
};

export const formatDeliveryOrderByCustomerDate = (row: any) => {
  const deliveryDate = row?.delivery_note_date || row?.delivery_date;

  return deliveryDate ? formatDBDate(deliveryDate) : "-";
};

export const formatDeliveryOrderByCustomerQty = (detail: any) =>
  `${detail?.converted_qty ?? 0} | ${detail?.base_qty ?? 0}`;

export const groupDeliveryOrdersByCustomer = (data: any[] = []) => {
  const groupedByCustomer: Record<string, any[]> = {};

  data.forEach((entry) => {
    const customerLabel = formatDeliveryOrderByCustomerLabel(entry);

    if (!groupedByCustomer[customerLabel]) {
      groupedByCustomer[customerLabel] = [];
    }

    groupedByCustomer[customerLabel].push(entry);
  });

  return Object.entries(groupedByCustomer).map(([customerLabel, orders]) => ({
    customerLabel,
    orders,
  }));
};
